package com.eladfinish.bible.contest.screens.search.mvi

import com.eladfinish.bible.contest.arch.EffectKt
import dev.icerock.moko.resources.desc.StringDesc

sealed interface SearchEffect : EffectKt {
    data object ShowKeyboard : SearchEffect
    data object HideKeyboard : SearchEffect
    data object ScrollSignsContainerToStart : SearchEffect
    data object ShowHistorySavedHint : SearchEffect

    data class ShowMessage(
        val message: StringDesc,
    ) : SearchEffect

    data class ShowRawMessage(
        val message: String,
    ) : SearchEffect

    data class ShowSearchSuggestion(
        val message: StringDesc,
        val suggestedExpression: String,
    ) : SearchEffect

    data class Vibrate(
        val milliseconds: Long,
    ) : SearchEffect

    data class CopyToClipboard(
        val text: String,
    ) : SearchEffect

    data class ShareSearch(
        val text: String,
    ) : SearchEffect
}
